import React from 'react'

import InnerHtml from '../../../components/innerHtml'

const SearchPageArticle = ({html}) => {
  if (!html) {
    return null
  }

  return (
    <section className='page-section -color-grey-light -border-top -border-bottom'>
      <div className='search-page-content-article__text-section'>
        <div className='grid-container'>
          <div className='sidebar-s -size-fixed-tablet is-hidden-phone'>
            <div className='search-page-content__sidebar-spacer' />
          </div>
          <div className='content-l -size-scale-tablet content-right'>
            <div className='fds-c-text-preformatted'>
              <InnerHtml>
                {html}
              </InnerHtml>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default SearchPageArticle



// WEBPACK FOOTER //
// ./client/pages/search/content/searchPageArticle.js